module.exports = __webpack_public_path__ + "img/fish.eae65c84.png";